/*
 *  Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { isNotEmpty, isNotNil } from "~/tools";
import { Environment } from "../../types";

type Props = {
  environment?: Environment;
  assignments?: {
    appCount: number;
    envCount: number;
  };
};

export function useApplicationEnvironment({ environment, assignments }: Props) {
  const hideAssignments =
    assignments == null ||
    (assignments.appCount < 2 && assignments.envCount < 2);

  const applicationNid = environment?.application.nid ?? "";
  const environmentNid = environment?.nid ?? "";

  const isData = isNotEmpty(applicationNid) && isNotEmpty(environmentNid);

  const hasApplications = isNotNil(assignments)
    ? assignments.appCount !== 0
    : false;

  return {
    hideAssignments,
    applicationNid,
    environmentNid,
    isData,
    hasApplications,
  };
}
